import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { formatCurrency, parseNumber, required, email } from 'entoro-shared';
import { withStyles, Button } from 'material-ui';
import { FormControl, FormHelperText } from 'material-ui/Form';
import MaterialTextField from 'material-ui/TextField';
import { connect } from 'react-redux';

const CurrencyInput = ({
  input,
  meta: { touched, error },
  styleInput,
  ...custom
}) => {
  return (
    <FormControl
      classes={{ root: styleInput.formControlMargin }}
      fullWidth
      error={Boolean(touched && error)}
    >
      <MaterialTextField
        {...input}
        error={Boolean(touched && error)}
        fullWidth
        {...custom}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: styleInput.textFieldRoot,
            input: styleInput.textFieldInput,
          },
        }}
      />
      {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
};

const styles = (theme) => ({
  textFieldRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  textFieldInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  selectPadding: {
    padding: ' 3px',
  },
  InputLabelStyle: {
    top: '-10px',
    left: ' 10px',
  },

  listItemTextRoot: {
    fontSize: '16px',
    '& .MuiTypography-subheading-53': {
      fontSize: '15px',
    },
  },

  toolbarRoots: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogcontentRoot: {
    padding: '20px 0px 0px 24px',
  },
  formControlMargin: {
    marginTop: 30,
    marginBottom: '-20px',
  },
});

const TextField = ({
  input,
  meta: { touched, error },
  styleInput,
  ...custom
}) => {
  return (
    <FormControl
      classes={{ root: styleInput.formControlMargin }}
      fullWidth
      error={Boolean(touched && error)}
    >
      <MaterialTextField
        {...input}
        error={Boolean(touched && error)}
        fullWidth
        {...custom}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: styleInput.textFieldRoot,
            input: styleInput.textFieldInput,
          },
        }}
      />
      {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
};
const RegisterForm = reduxForm({
  form: 'ttwRegistrations',
})((props) => {
  const { handleSubmit, submitting, handleRegistration, classes } = props;
  return (
    <form onSubmit={handleSubmit(handleRegistration)}>
      <Field
        component={TextField}
        validate={[required]}
        name='firstName'
        placeholder='First Name'
        styleInput={classes}
        autoComplete='given-name'
      />
      <Field
        component={TextField}
        validate={[required]}
        name='lastName'
        placeholder='Last Name'
        styleInput={classes}
        autoComplete='family-name'
      />
      <Field
        component={TextField}
        validate={[required, email]}
        name='email'
        type='email'
        styleInput={classes}
        placeholder='you@example.com'
        autoComplete='email'
      />
      <Field
        component={TextField}
        validate={[required]}
        name='address'
        type='address'
        styleInput={classes}
        placeholder='3, Westham, NY, USA'
        autoComplete='address'
      />
      <Field
        component={TextField}
        validate={[required]}
        component={CurrencyInput}
        format={formatCurrency}
        parse={parseNumber}
        name='amount'
        styleInput={classes}
        placeholder='$ 40,000'
      />
      <br />

      <br />
      <br />

      <input
        type='submit'
        disabled={submitting}
        className={`button w-button ${submitting ? 'disabled-btn' : null}`}
        value={'Register'}
      />
    </form>
  );
});

export default connect()(withStyles(styles)(RegisterForm));



// WEBPACK FOOTER //
// ./src/components/TTWaters/RegisterForm.js